// components/CustomSearchBar.js
import * as React from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

const CustomSearchBar = ({ value, onChange, placeholder = "Search..." }) => {
    return (
        <Paper
            component="form"
            sx={{
                p: '2px 8px',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                maxWidth: 400,
                margin: '1rem auto',
                borderRadius: '12px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            }}
            onSubmit={(e) => e.preventDefault()}
        >
            <InputBase

                sx={{ ml: 1, flex: 1 }}
                placeholder={placeholder}
                inputProps={{ 'aria-label': placeholder, }}
                value={value}
                onChange={(e) => onChange(e.target.value)}

            />
            <IconButton disabled type="button" sx={{ p: '10px' }} >
                <SearchIcon />
            </IconButton>

        </Paper>
    );
};

export default CustomSearchBar;
